function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "L4rKfs~Qrm~k0Pk8MRsoza",
  x1: 32.012,
  x2: 15.881,
  y1: 32.012,
  y2: 15.881,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.242,
  stopColor: "#f2f2f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ccc"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 11.5,
  fill: "url(#L4rKfs~Qrm~k0Pk8MRsoza)"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "L4rKfs~Qrm~k0Pk8MRsozb",
  x1: 17.45,
  x2: 28.94,
  y1: 17.45,
  y2: 28.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0d61a9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.363,
  stopColor: "#0e5fa4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#135796"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#16528c"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 7,
  fill: "url(#L4rKfs~Qrm~k0Pk8MRsozb)"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "L4rKfs~Qrm~k0Pk8MRsozc",
  x1: 5.326,
  x2: 38.082,
  y1: 5.344,
  y2: 38.099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#889097"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.331,
  stopColor: "#848c94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#78828b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#64717c"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#L4rKfs~Qrm~k0Pk8MRsozc)",
  d: "M43.407,19.243c-2.389-0.029-4.702-1.274-5.983-3.493c-1.233-2.136-1.208-4.649-0.162-6.693 c-2.125-1.887-4.642-3.339-7.43-4.188C28.577,6.756,26.435,8,24,8s-4.577-1.244-5.831-3.131c-2.788,0.849-5.305,2.301-7.43,4.188 c1.046,2.044,1.071,4.557-0.162,6.693c-1.281,2.219-3.594,3.464-5.983,3.493C4.22,20.77,4,22.358,4,24 c0,1.284,0.133,2.535,0.364,3.752c2.469-0.051,4.891,1.208,6.213,3.498c1.368,2.37,1.187,5.204-0.22,7.345 c2.082,1.947,4.573,3.456,7.34,4.375C18.827,40.624,21.221,39,24,39s5.173,1.624,6.303,3.971c2.767-0.919,5.258-2.428,7.34-4.375 c-1.407-2.141-1.588-4.975-0.22-7.345c1.322-2.29,3.743-3.549,6.213-3.498C43.867,26.535,44,25.284,44,24 C44,22.358,43.78,20.77,43.407,19.243z M24,34.5c-5.799,0-10.5-4.701-10.5-10.5c0-5.799,4.701-10.5,10.5-10.5S34.5,18.201,34.5,24 C34.5,29.799,29.799,34.5,24,34.5z"
});

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ea0764cd.svg";
export { ForwardRef as ReactComponent };